<template>
<div class="root">
  <div style="
    background-size: cover;
    background-position: 50% 50%;
    filter: blur(8px);
    -webkit-filter: blur(1vw);
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: -2;
    opacity: .5;
" :style="{backgroundImage: $ui.backgroundDeclaration}" v-if="$ui._backgroundUrl"></div>
  <div id="q-app">
    <router-view/>
  </div>
</div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    userContact () {
      return this.auth$.authInfo.user
    }
  },
  watch: {
    userContact () {
      Object.assign(this.$userContact, { 'email': this.userContact.email })
    }
  }
}
</script>

<style>
#q-app {
  background: none;
}
</style>
